import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { NotificationPlayerLevelState } from "@/domains/notification/constants/notificationState";
import { NotificationStatus } from "@/domains/notification/constants/status";
import NotificationIndicator from "@/domains/notification/components/NotificationIndicator";

type Props = {
  className?: string;
} & NotificationPlayerLevelState;

export default function NotificationPlayerLevel({ className, level, increase, points }: Props) {
  const { t } = useTranslation("notification");

  const percent = Math.trunc((points[0] / points[1]) * 100);

  return (
    <div className={cn("flex flex-col items-center z-1", className)}>
      <motion.div
        initial={{ opacity: 0, translateY: "-100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "-100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          delay: 0.1,
          duration: 0.3,
        }}
        className="flex items-center gap-2.5 mt-5"
      >
        <div className="relative flex items-center justify-center">
          <NotificationIndicator
            fillPercent={percent}
            className="w-[3.75rem] h-[3.75rem]"
            status={increase ? NotificationStatus.Success : NotificationStatus.Error}
          />
          <div className="absolute text-20 font-bold text-white">{level}</div>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.4,
        }}
        className={clsx(
          "text-18 text-white font-bold mt-2.5 px-5 py-2 whitespace-nowrap rounded-[0.5rem]",
          "bg-gradient-to-r",
          increase ? "from-[#56FF70]/30 to-[#56FF70]/10" : "from-[#FF4E4E]/30 to-[#FF4E4E]/10",
        )}
      >
        {increase ? t("notification.levelIncreased") : t("notification.levelDecreased")}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.7,
        }}
        className="mt-2.5"
      >
        <div className="text-16 text-white font-bold text-center">
          <span className={increase ? "text-[#56FF70]" : "text-[#FF4E4E]"}>{points[0]}</span> /{" "}
          {points[1]}
        </div>
        <div className="uppercase text-12 font-bold text-white mt-1 text-center">
          {t("notification.progressPoints")}
        </div>
      </motion.div>
    </div>
  );
}
